module.exports = function slugify(id, name) {
  const str = [id, name]
    .join(' ')
    .trim()
    .toLowerCase()
    .replace(/[^A-Z0-9]/gi, '-')
    .replace(/[-]+/g, '-');
  return str[str.length - 1] === '-' ? str.slice(0, -1) : str;
};
